import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
} from "@syncfusion/ej2-react-grids";

export default function StoreGrid({ data = [] }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "Store_List_GridID_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="Store_List_GridID"
              dataSource={data}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"350px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="150"
                  textAlign="Center"
                  isPrimaryKey={true}
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="StoreCode"
                  headerText="Store Code"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StoreName"
                  headerText="Store Name"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StoreNameFull"
                  headerText="Full Name"
                  width="350"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Type"
                  headerText="Type"
                  width="180"
                  textAlign="Center"
                />
                <ColumnDirective
                  field="StoreRegion"
                  headerText="Region"
                  width="180"
                  textAlign="Center"
                />
                 <ColumnDirective
                  field="Address"
                  headerText="Address"
                  width="200"
                  textAlign="Left"
                />
                 <ColumnDirective
                  field="Address2"
                  headerText="Address2"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="City"
                  headerText="City"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PostalCode"
                  headerText="Postal Code"
                  width="200"
                  textAlign="Center"
                />
                <ColumnDirective
                  field="Country"
                  headerText="Country"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StoreManagerID"
                  headerText="Manager"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PhoneNo"
                  headerText="Phone"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="IsActive"
                  displayAsCheckBox={true}
                  headerText="Active"
                  width="180"
                  textAlign="Center"
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
}